import React from 'react'
import { Dropdown } from "react-bootstrap";
import Login from "../../Auth/Login";
import Chat from "./../Chat";
import Logo from "./../Logo";
import Register from "../../Auth/Register";
import {Event, BRAND} from "../../../../Helper";

import Wallet from "../../../Components/User/Wallet";


var show = true;

class Header extends React.Component {
        
    collapse = () =>{
        show = !show;
        Event.emit('toggle_sidebar', show);
    }
    render() {
        const { t, tab } = this.props;
        return (
            <div>
                        <div className="d-flex justify-content-between" id={'topbar2'}>
                            <Logo brand={BRAND} />  
                            <div>
                            <Login t={t} /><Register t={t} />
                            </div>
                            
                           
                           
                            
                        </div>
                        {tab && (
          <ul className="casino nav nav-pills nav-fill my-2 mx-1 d-none">
            <li className="nav-item">
              <a
                className={`nav-link ${tab === "aviator" ? "active" : ""}`}
                href="/"
              >
                AVIATOR
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${tab === "sports" ? "active" : ""}`}
                href="/sports"
              >
                SPORTS
              </a>
            </li>
            
          </ul>
        )}

        </div>                
        );
    }
}

export default Header;